module.exports = __webpack_public_path__ + "img/topfenstrudel.2ab328ce.png";